import CurrencyFormat from "react-currency-format";

export const RenderNonLTInsulation = ({
	params,
	const_var,
	item,
	summaryViewData,
	compareData,
	compareParamData,
	comparePricingData,
	showCustomInsulation,
	heritageNoInsulationCaseCenterBuilding,
	heritageNoInsulationCaseLeftLean,
	heritageNoInsulationCaseRightLean,
	heritageNoInsulationCaseFrontLean,
	heritageNoInsulationCaseBackLean
}) => {
	if (
		!(
			(params.p_c_i || params.p_f_i || params.p_r_o) &&
			showCustomInsulation &&
			(params.p_i_o != 0 || params.p_c_i) &&
			((comparePricingData != "" && Object.keys(comparePricingData).length > 0 && comparePricingData?.insulation?.length > 0) ||
				(const_var.a_p_d_a && const_var.a_p_d_a != undefined && const_var.cbInsulation != undefined && (summaryViewData?.insulation_type || params.p_c_i) && comparePricingData == ""))
		)
	) {
		return;
	}

	return (
		<>
			<hr />
			<div className="section-title-wrapper ">
				<h6 className="section-title mb-0">
					Insulation {compareData != "" && compareParamData != "" && item?.compareManufactureIndex != "0" ? <>{compareParamData.p_c_i == true && <>(Custom)</>}</> : <>{params.p_c_i && <>(Custom)</>}</>}
				</h6>
			</div>
			<div className="highlight-with-bg">
				<div className="summary-row d-flex justify-content-between">
					<div className={`summary-label ${params.p_c_i == true ? " d-none" : ""}`}>
						<>
							<span className="summary-label-title">Type</span>
							{" - "}
							{compareData != "" && compareParamData != "" && item?.compareManufactureIndex != "0" ? (
								<>
									{compareParamData.p_c_i != true && (
										<>
											{compareParamData.p_c_i == true
												? " (Custom)"
												: compareParamData.p_r_o == true
													? " " + summaryViewData.insulationJsonCompare[compareParamData.p_i_o] + " (Roof Only)"
													: " " + summaryViewData.insulationJsonCompare[compareParamData.p_i_o] + " (Full Building)"}
										</>
									)}
								</>
							) : (
								<>
									{params.p_c_i != true && (
										<>
											{params.p_c_i == true
												? " (Custom)"
												: params.p_r_o == true
													? " " + const_var.insulationJson[params.p_i_o] + " (Roof Only)"
													: " " + const_var.insulationJson[params.p_i_o] + " (Full Building)"}
										</>
									)}
								</>
							)}
						</>
					</div>
					<div className="summary-info">
						<aside className="summary-info-right">
							{params.p_c_i != true && (params.p_r_o || params.p_f_i) && (
								<CurrencyFormat
									value={compareData ? (summaryViewData?.insulation_price ?? 0) : (const_var.post_data.building.insulation_price ?? 0)}
									displayType={"text"}
									thousandSeparator={true}
									prefix={"$"}
								/>
							)}
						</aside>
					</div>
				</div>
			</div>
			{params.p_c_i == true && (
				<>
					{compareData != undefined && compareData != "" && item?.compareManufactureIndex != "0" ? (
						<>
							{summaryViewData?.insulation_type?.insulation_wall &&
								!heritageNoInsulationCaseCenterBuilding &&
								renderCustomInsWallName(summaryViewData.insulation_type.insulation_wall, "center", summaryViewData.insulation_price, summaryViewData.insulationJsonCompare[compareParamData.p_i_o])}
							{summaryViewData?.leanto && summaryViewData?.leanto?.length > 0 && (
								<div>
									{Object.entries(summaryViewData?.leanto || []).map(([key, value]) => {
										return (
											<>
												{value.leanto_type == 1 &&
													params.add_left_lean &&
													value?.insulation_type?.insulation_wall &&
													!heritageNoInsulationCaseLeftLean &&
													compareParamData?.insulation?.leftLean?.insulationId &&
													value?.insulationArrayForLeantoLeftCompare?.[compareParamData?.insulation?.leftLean?.insulationId] &&
													renderCustomInsWallName(
														value?.insulation_type?.insulation_wall,
														"left",
														value?.insulation_price,
														value?.insulationArrayForLeantoLeftCompare?.[compareParamData.insulation.leftLean.insulationId]?.name
													)}
												{value.leanto_type == 2 &&
													params.add_right_lean &&
													value?.insulation_type?.insulation_wall &&
													!heritageNoInsulationCaseRightLean &&
													compareParamData?.insulation?.rightLean.insulationId &&
													value?.insulationArrayForLeantoRightCompare?.[compareParamData.insulation.rightLean.insulationId] &&
													renderCustomInsWallName(
														value.insulation_type.insulation_wall,
														"right",
														value.insulation_price,
														value.insulationArrayForLeantoRightCompare[compareParamData.insulation.rightLean.insulationId].name
													)}
												{value.leanto_type == 3 &&
													params.add_front_lean &&
													value?.insulation_type?.insulation_wall &&
													!heritageNoInsulationCaseFrontLean &&
													compareParamData?.insulation?.frontLean?.insulationId &&
													value?.insulationArrayForLeantoFrontCompare?.[compareParamData.insulation.frontLean.insulationId] &&
													renderCustomInsWallName(
														value.insulation_type.insulation_wall,
														"front",
														value.insulation_price,
														value.insulationArrayForLeantoFrontCompare[compareParamData.insulation.frontLean.insulationId].name
													)}
												{value.leanto_type == 4 &&
													params.add_back_lean &&
													value.insulation_type &&
													!heritageNoInsulationCaseBackLean &&
													compareParamData?.insulation?.backLean?.insulationId &&
													value?.insulationArrayForLeantoBackCompare?.[compareParamData.insulation.backLean.insulationId] &&
													renderCustomInsWallName(
														value.insulation_type.insulation_wall,
														"back",
														value.insulation_price,
														value.insulationArrayForLeantoBackCompare[compareParamData.insulation.backLean.insulationId].name
													)}
											</>
										);
									})}
								</div>
							)}
						</>
					) : (
						<>
							{const_var.a_p_d_a &&
								const_var.insulationPriceJson.insulation_wall &&
								!heritageNoInsulationCaseCenterBuilding &&
								renderCustomInsWallName(const_var.insulationPriceJson.insulation_wall, "center", const_var.post_data.building.insulation_price, const_var.insulationJson[params.p_i_o])}
							{summaryViewData?.leanto?.length > 0 && (
								<div>
									{Object.entries(summaryViewData?.leanto || []).map(([key, value]) => {
										return (
											<>
												{value.leanto_type == 1 &&
													!heritageNoInsulationCaseLeftLean &&
													params.add_left_lean &&
													value?.insulation_type?.insulation_wall &&
													const_var?.insulationArrayForLeantoLeft?.insulation_wall &&
													renderCustomInsWallName(
														const_var.insulationArrayForLeantoLeft.insulation_wall,
														"left",
														value.insulation_price,
														const_var.insulationJsonLeanTo[params.insulation["leftLean"]["insulationId"]],
														value.leanto_style == "gable"
													)}
												{value.leanto_type == 2 &&
													!heritageNoInsulationCaseRightLean &&
													params.add_right_lean &&
													value.insulation_type?.insulation_wall &&
													const_var?.insulationArrayForLeantoRight?.insulation_wall &&
													renderCustomInsWallName(
														const_var.insulationArrayForLeantoRight.insulation_wall,
														"right",
														value.insulation_price,
														const_var.insulationJsonLeanTo[params.insulation["rightLean"]["insulationId"]],
														value.leanto_style == "gable"
													)}
												{value.leanto_type == 3 &&
													!heritageNoInsulationCaseFrontLean &&
													params.add_front_lean &&
													value.insulation_type?.insulation_wall &&
													const_var?.insulationArrayForLeantoFront?.insulation_wall &&
													renderCustomInsWallName(
														const_var.insulationArrayForLeantoFront.insulation_wall,
														"front",
														value.insulation_price,
														const_var.insulationJsonLeanTo[params.insulation["frontLean"]["insulationId"]],
														value.leanto_style == "gable"
													)}
												{value.leanto_type == 4 &&
													!heritageNoInsulationCaseBackLean &&
													params.add_back_lean &&
													value?.insulation_type?.insulation_wall &&
													const_var?.insulationArrayForLeantoBack?.insulation_wall &&
													renderCustomInsWallName(
														const_var.insulationArrayForLeantoBack.insulation_wall,
														"back",
														value.insulation_price,
														const_var.insulationJsonLeanTo[params.insulation["backLean"]["insulationId"]],
														value.leanto_style == "gable"
													)}
											</>
										);
									})}
								</div>
							)}
						</>
					)}
				</>
			)}
		</>
	);
};

export const renderCustomInsWallName = (wallData, type, insPrice, insulationName = undefined, isGable) => {
	if (wallData) {
		let isInsulationAdded = Object.entries(wallData).find(([key, val]) => val == true || val == "included");
		return (
			<>
				{isInsulationAdded != undefined && (
					<div className="highlight-with-bg">
						<div className="summary-row d-flex justify-content-between">
							<div className="summary-label">
								<div className="insulation-calc">
									<div className="ins-data">
										{type == "center" ? (
											<>
												<div className="ins-for-head">
													Center Building <span>{"- Type: " + insulationName}</span>
												</div>
											</>
										) : type == "front" ? (
											<>
												<div className="ins-for-head">
													Front {isGable ? "Building" : `Lean-to's`} <span>{"- Type: " + insulationName}</span>
												</div>
											</>
										) : type == "back" ? (
											<>
												<div className="ins-for-head">
													Back {isGable ? "Building" : `Lean-to's`} <span>{"- Type: " + insulationName}</span>
												</div>
											</>
										) : type == "left" ? (
											<>
												<div className="ins-for-head">
													Left {isGable ? "Building" : `Lean-to's`} <span>{"- Type: " + insulationName}</span>
												</div>
											</>
										) : type == "right" ? (
											<>
												<div className="ins-for-head">
													Right {isGable ? "Building" : `Lean-to's`} <span>{"- Type: " + insulationName}</span>
												</div>
											</>
										) : (
											<></>
										)}
										{`(`}
										{Object.entries(wallData).map(([key, val]) => {
											return (
												<>
													{(val == true || val == "included") && (
														<span className="wall-nm">
															{this.props.const_var.wallNameArray[key]}
															<span>, </span>
														</span>
													)}
												</>
											);
										})}
										{`)`}
									</div>
								</div>
							</div>
							<div className="summary-info">
								<aside className="summary-info-right">{insPrice != undefined && insPrice != null && <CurrencyFormat value={insPrice} displayType={"text"} thousandSeparator={true} prefix={"$"} />}</aside>
							</div>
						</div>
					</div>
				)}
			</>
		);
	} else {
		return <></>;
	}
};

export const InsulationSummary = ({ const_var, summaryViewData, heritageNoInsulationCaseCenterBuilding }) => {
	return (
		<div className="highlight-with-bg">
			{const_var.a_p_d_a && const_var.cbInsulation == undefined && !heritageNoInsulationCaseCenterBuilding ? (
				<div className="summary-row d-flex justify-content-between">
					<div className="summary-label">
						<span className="summary-label-title">Insulation</span>
						{" - "}
						<span className="dark-span">
							{this.props.params.p_r_o == true
								? this.props.const_var.insulationJson[this.props.params.p_i_o] + "(Roof Only)"
								: this.props.const_var.insulationJson[this.props.params.p_i_o] + "(Full Building)"}{" "}
						</span>
					</div>
					<div className="summary-info">
						<aside className="summary-info-right">
							{summaryViewData?.insulation_price != null && summaryViewData?.insulation_price != undefined && (
								<CurrencyFormat
									fixedDecimalScale="2"
									decimalSeparator="."
									decimalScale="2"
									value={summaryViewData != undefined ? summaryViewData.insulation_price : 0}
									displayType={"text"}
									thousandSeparator={true}
									prefix={"$"}
								/>
							)}
						</aside>
					</div>
				</div>
			) : (
				""
			)}
		</div>
	);
};
